import React, { useState, useEffect } from "react"
import i18n from "../../../../services/i18n"
import { Form, Input, Button, InputNumber, Switch, Space, Row, Col, Typography, message, Alert } from "antd"
import { Mail, Send, CheckCircle, Lock, Server } from "react-feather"
import { useQuery, useMutation } from "@tanstack/react-query"
import {
  GET_EMAIL_SETTINGS,
  SAVE_EMAIL_SETTINGS,
  SEND_TEST_EMAIL,
} from "../../../../rest-api/queries/emailSettings"

export default function EmailSettingsSection() {
  const [form] = Form.useForm()
  const [testEmail, setTestEmail] = useState("")

  const { data: settingsData, isLoading: loadingSettings, refetch: refetchSettings } = useQuery(
    ["GET_EMAIL_SETTINGS"],
    GET_EMAIL_SETTINGS,
    {
      onSuccess: (data: any) => {
        if (data) {
          form.setFieldsValue({
            smtpHost: data.smtpHost || "smtp.gmail.com",
            smtpPort: data.smtpPort || 587,
            smtpUser: data.smtpUser || data.senderEmail || "",
            senderEmail: data.senderEmail || "",
            senderName: data.senderName || "Zenith Digital CRP",
            enableSsl: data.enableSsl !== false,
          })
          if (data.senderEmail && !testEmail) {
            setTestEmail(data.senderEmail)
          }
        }
      },
    }
  )

  const { mutate: saveSettingsMutation, isLoading: saving } = useMutation(SAVE_EMAIL_SETTINGS, {
    onSuccess: (res: any) => {
      message.success(res?.Message || "Email sozlamalari muvaffaqiyatli saqlandi!")
      refetchSettings()
    },
    onError: (err: any) => {
      message.error(i18n.t("msgSaveError") + ": " + (err?.response?.data?.Message || err.message))
    },
  })

  const { mutate: sendTestMutation, isLoading: sendingTest } = useMutation(SEND_TEST_EMAIL, {
    onSuccess: (res: any) => {
      message.success(res?.Message || "Test xabari yuborildi!")
    },
    onError: (err: any) => {
      message.error(i18n.t("msgTestEmailFailed") + ": " + (err?.response?.data?.Message || err.message))
    },
  })

  const handleSave = (values: any) => {
    saveSettingsMutation({
      smtpHost: values.smtpHost,
      smtpPort: values.smtpPort,
      smtpUser: values.smtpUser,
      smtpPassword: values.smtpPassword,
      senderEmail: values.senderEmail,
      senderName: values.senderName,
      enableSsl: values.enableSsl,
    })
  }

  const handleSendTest = () => {
    if (!testEmail.trim()) {
      message.warning(i18n.t("msgEnterTestEmail"))
      return
    }
    sendTestMutation({ toEmail: testEmail.trim() })
  }

  return (
    <div style={{ padding: "4px 0" }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSave}
        initialValues={{
          smtpHost: "smtp.gmail.com",
          smtpPort: 587,
          enableSsl: true,
        }}
      >
        <Row gutter={12}>
          <Col xs={24} md={16}>
            <Form.Item
              name="smtpHost"
              label="SMTP Server (Host)"
              rules={[{ required: true, message: "SMTP host kiritilishi shart" }]}
            >
              <Input placeholder="smtp.gmail.com yoki mail.zendig.uz" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
              name="smtpPort"
              label="Port"
              rules={[{ required: true, message: "Port kiritilishi shart" }]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="587 yoki 465" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col xs={24} md={12}>
            <Form.Item
              name="senderEmail"
              label={i18n.t("emailFromLabel")}
              rules={[{ required: true, message: "Email kiritilishi shart" }]}
            >
              <Input placeholder="info@zendig.uz yoki gmail" />
            </Form.Item>
          </Col>
          <Col xs={24} md={12}>
            <Form.Item
              name="smtpPassword"
              label="SMTP Parol / App Password"
              extra="Gmail uchun 'App Password' ishlatiladi"
            >
              <Input.Password placeholder="••••••••••••••••" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={12}>
          <Col xs={24} md={16}>
            <Form.Item name="senderName" label={i18n.t("emailFromName")}>
              <Input placeholder="Zenith Digital CRP" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item name="enableSsl" label="SSL / TLS Xavfsizlik" valuePropName="checked">
              <Switch checkedChildren="ON" unCheckedChildren="OFF" />
            </Form.Item>
          </Col>
        </Row>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={saving}
            style={{
              borderRadius: 6,
              background: "#2563EB",
              fontWeight: 600,
            }}
          >
            Sozlamalarni saqlash
          </Button>
        </div>
      </Form>

      <hr style={{ border: "none", borderTop: "1px solid rgba(0,0,0,0.06)", margin: "16px 0" }} />

      <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
        <Input
          placeholder={i18n.t("phTestEmail")}
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          style={{ flex: 1, borderRadius: 6 }}
        />
        <Button
          type="default"
          icon={<Send size={14} style={{ marginRight: 4 }} />}
          onClick={handleSendTest}
          loading={sendingTest}
          style={{ borderRadius: 6 }}
        >
          Test xabari yuborish
        </Button>
      </div>
    </div>
  )
}
